import { render, staticRenderFns } from "./ProjectShow.vue?vue&type=template&id=a1ce9fac&scoped=true&"
import script from "./ProjectShow.vue?vue&type=script&lang=js&"
export * from "./ProjectShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ce9fac",
  null
  
)

export default component.exports